import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { translateFn } from '../../../utils/translator.helper';
import { TemplateState } from "../../../types/common/types";
import { GroupBy } from "../types";
import { getTimeRangeConfig } from '../utils';

export class IncidentsActivityPanelView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$title = this.shadow.querySelector('gz-title');
    this.dom.$timeRangeSlider = this.shadow.querySelector('gz-time-range-slider');
    this.dom.$singleSelectGroup = this.shadow.querySelector('gz-single-select');
    this.dom.$collapsibleTimeline = this.shadow.querySelector('gz-timeline');
    this.dom.$inputSearch = this.shadow.querySelector('gz-input-search');
    this.dom.$collapseBtn = this.shadow.querySelector('#collapseBtn');
    this.dom.$uncollapsBtn = this.shadow.querySelector('#uncollapsBtn');
  }

  buildSuccessView(data: any) {
    this.resetTemplateState(this.dom.$wrapper);

    this.dom.$title.innerText = translateFn('ALERTS');
    if (this.dependencies.validate !== true) {
      return this.buildErrorView();
    }

    this.dom.$inputSearch.placeholder = translateFn('Search');

    const timeConfig = getTimeRangeConfig(this.dependencies.alerts);
    this.dom.$timeRangeSlider.timeRangeConfig = timeConfig;
    this.dom.$timeRangeSlider.valueMinTimestamp = timeConfig.minTimestamp;
    this.dom.$timeRangeSlider.valueMaxTimestamp = timeConfig.maxTimestamp;
    this.dom.$timeRangeSlider.translateStrings = {
      confirmButton: translateFn('Apply'),
      cancelButton: translateFn('Cancel'),
      fromLabel: translateFn('From'),
      toLabel: translateFn('To'),
    };

    this.dom.$singleSelectGroup.label = translateFn('Group');
    this.dom.$singleSelectGroup.filterOptions = [{
      label: translateFn('By timeline'),
      value: GroupBy.TIMELINE
    }, {
      label: translateFn('By killchain phase'),
      value: GroupBy.KILLCHAIN_PHASE
    }, {
      label: translateFn('By severity'),
      value: GroupBy.SEVERITY
    }, {
      label: translateFn('By sensor'),
      value: GroupBy.SENSOR
    }, {
      label: translateFn('By incident ID'),
      value: GroupBy.INCIDENT_ID
    }, {
      label: translateFn('By node'),
      value: GroupBy.NODE
    }, {
      label: translateFn('By alert name'),
      value: GroupBy.ALERT_NAME
    }];
    this.dom.$singleSelectGroup.value = GroupBy.TIMELINE;
    this.dom.$singleSelectGroup.dropdownMenu.labelWidth = 'full';
  }

  buildErrorView() {
    this.resetTemplateState(this.dom.$wrapper);

    this.dom.$timeRangeSlider.remove();
    this.dom.$singleSelectGroup.remove();
    this.dom.$collapsibleTimeline.remove();
    this.dom.$inputSearch.remove();

    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }
}
